import styles from "./DemoVideo.module.css";

export interface DemoVideoProps {
  /** YouTube video id (the part after `v=`). */
  youtubeId: string;
  /** Accessible name for the player — the iframe's title. */
  title: string;
}

/**
 * The demo embed on the apex page (routes/home.tsx).
 *
 * YouTube's own player chrome is the affordance: it draws the play button,
 * the poster frame and the controls, so nothing of ours sits over the top of
 * it. `youtube-nocookie` is the host because the apex page is a security
 * surface before it is anything else, and the reader who lands on it is
 * usually checking whether an emailed link was genuine.
 */
export function DemoVideo({ youtubeId, title }: DemoVideoProps) {
  return (
    <div className={styles.frame}>
      <iframe
        className={styles.player}
        src={`https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0&modestbranding=1`}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}
